// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"8":"e285dde2","167":"9e0d6681","177":"cd6c453a","191":"14505a49","279":"a203832c","297":"ff3eb07a","511":"b7b4470e","906":"0a005f81"}[chunkId] + ".css";
};